/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Map } from 'immutable';
import { get } from 'lodash';
import Constants from '../../constants';

const initialState: any = Map();

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case Constants.LOCATION_SETTINGS_EXCEPTION:
      return state
        .setIn([`${payload.locationGuid}`, 'errors'], payload.errors)
        .setIn([`${payload.locationGuid}`, 'loading'], true);

    case Constants.LOCATION_SETTINGS_REQUESTED:
      return state
        .setIn([`${payload.locationGuid}`, 'data'], state.getIn([`${payload.locationGuid}`, 'data'], null))
        .setIn([`${payload.locationGuid}`, 'errors'], [])
        .setIn([`${payload.locationGuid}`, 'loading'], true);

    case Constants.LOCATION_SETTINGS_RESPONDED:
      return state
        .setIn([`${payload.locationGuid}`, 'data'], get(payload, 'response.data'))
        .setIn([`${payload.locationGuid}`, 'errors'], [])
        .setIn([`${payload.locationGuid}`, 'loading'], false);

    default:
      return state;
  }
};
